<template>
    <v-dialog v-model="show" persistent width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2 py-2" primary-title>
                <v-layout justify-space-between align-center>
                    <div>
                        {{$t('createACampaign') | capitalize}}
                    </div>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" @submit="submit" v-model="formValid">
                    <v-text-field
                        v-model="name"
                        :label="$filters.capitalize($t('name'))"
                        :rules="formRules.required"
                    ></v-text-field>
                    <v-text-field
                        v-model="description"
                        :label="$filters.capitalize($t('description'))"
                    ></v-text-field>
                    <!-- <v-select
                        v-model="bot"
                        :label="$filters.capitalize($t('bot'))"
                        :items="botList"
                        :rules="formRules.required"
                    ></v-select> -->
                    <v-layout justify-end>
                        <v-btn type="submit" color="primary">{{$t('create')}}</v-btn>
                        <v-btn @click="close">{{$t('cancel')}}</v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import FormMixin from '@/mixins/FormMixin'
import ProjectService from '@/services/project.service'
import BotService from '@/services/bot.service'
import DialogPromiseMixin from '@/mixins/DialogPromiseMixin'
import { mapState } from 'vuex'

export default {
    name: 'ProjectCreator',
    mixins: [DialogPromiseMixin, FormMixin],
    data () {
        return {
            name: '',
            description: '',
            bot: '',
            botList: []
        }
    },
    computed: {
        ...mapState({
            token: state => state.auth.token
        })
    },
    methods: {
        submitValidForm () {
            ProjectService.createProject(this.name, this.description, this.bot).then(
                result => {
                    this.promise.resolve(result.data)
                    this.close()
                    this.clearForm()
                },
                this.$appService.handleRequestError(this.$t('canNotCreate', { item: this.$t('campaign') }))
            )
        },
        // getBotList () {
        //     BotService.getBotList().then(
        //         result => {
        //             this.botList = result.data.map(item => {
        //                 return {
        //                     text: item.name,
        //                     value: item.code
        //                 }
        //             })
        //         }
        //     )
        // },
        close () {
            this.show = false
            this.$emit('close')
            this.$refs.form.reset()
        }
    },
    watch: {
        token: {
            immediate: true,
            handler: function (token) {
                if (token) {
                    // this.getBotList()
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
